"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = '1.19.0';
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/places.js/src/version.js
 ** module id = 1536
 ** module chunks = 0
 **/